export default function (instance) {
  return {
    getCards() {
      return instance.get("/cards/cardlist/");
    },
    getSolos() {
      return instance.get("/solotrainings/get");
    },
    sellSolo(payload) {
      return instance.post("/visits/register", payload);
    },
    sellGuestSolo(payload) {
      return instance.post("/visits/register/guest", payload);
    },
    getProducts(params) {
      return instance.get("/v2/products/list", { params: params });
    },
    getProduct(productId) {
      return instance.get(`/v2/products/${productId}`);
    },
    deleteProduct(productId) {
      return instance.delete(`/v2/products/${productId}`);
    },
    updateCard(productId, payload) {
      return instance.put(`/v2/products/cards/${productId}`, payload);
    },
    updateSolo(productId, payload) {
      return instance.put(`/v2/products/solos/${productId}`, payload);
    }
  };
}
